import * as React from 'react';
import { MobileScreen } from '@relay-towing/ui';
import { useRefetchOnScreen } from '../../hooks/useRefetchOnScreen';
import { ShellPills } from './ShellPills';

/**
 * A tab's screen: the pills along the top, and room for the tab bar.
 * Pulling down from the top fetches again everything the screen is
 * showing, as a phone's browser reloads a page, without reloading the app:
 * the queries on screen are the ones refetched, so where you were stays.
 */
export function TabScreen({
  header,
  children,
}: {
  /**
   * A MobileHeader in place of the pills, for a screen opened from a tab's
   * list that keeps the tab bar: Drivers, from Operations.
   */
  header?: React.ReactNode;
  children: React.ReactNode;
}) {
  const refetch = useRefetchOnScreen();
  return (
    <MobileScreen
      header={header}
      overlay={header ? undefined : <ShellPills />}
      tabBar
      onRefresh={refetch}
    >
      {children}
    </MobileScreen>
  );
}
